<template>
  <div class="prize-num" v-if="num > 1">
    X{{ num }}
  </div>
</template>

<script>
export default {
  props: {
    num: Number
  }
}
</script>

<style lang="scss" scoped>
.prize-num {
  position: absolute;
  @include px2res(bottom, 10);
  @include px2res(right, 14);
  @include px2res(font-size, 26);
}
</style>



// WEBPACK FOOTER //
// src/components/business-base/prize-num/index.vue